module.exports = __webpack_public_path__ + "static/media/signal-logo.06879a2e.png";